import { FieldDef, SearchParams } from './types';

export const FIELDS: FieldDef[] = [
  { key: 'job_titles',          label: 'Job Titles',          kind: 'text-tags' },
  { key: 'locations',           label: 'Locations',           kind: 'text-tags' },
  { key: 'companies',           label: 'Companies',           kind: 'text-tags' },
  { key: 'schools',             label: 'Schools',             kind: 'string-array' },
  { key: 'skills',              label: 'Skills',              kind: 'string-array' },
  { key: 'keywords',            label: 'Keywords',            kind: 'keywords' },
  { key: 'years_of_graduation', label: 'Years of Graduation', kind: 'range' },
  { key: 'years_of_experience', label: 'Years of Experience', kind: 'range' },
];

export const FIELDS_BY_KEY: Partial<Record<keyof SearchParams, FieldDef>> =
  (Object as any).fromEntries(FIELDS.map(f => [f.key, f]));

export function defaultParams(): SearchParams {
  return {
    job_titles: [],
    locations: [],
    companies: [],
    schools: [],
    skills: [],
    keywords: '',
    years_of_graduation: { min: 1973, max: 2033 },
    years_of_experience: { min: 0, max: 30 },
  };
}
